import { Skeleton, SkeletonProps } from '@mui/material';

interface SkeletonLoadingProps extends SkeletonProps {
  isLoading: boolean;
}


export function SkeletonLoading({ isLoading, children, ...props }: SkeletonLoadingProps): React.ReactElement | null {
  if (!isLoading) {
    return children as React.ReactElement;
  }

  return (
    <Skeleton variant='rectangular' height='100%' width='100%' {...props}>
      {children}
    </Skeleton>
  )
}